// use client: onLoad race — the hero <img> is server-rendered, so it can finish
// loading (often from cache) before React hydrates and attaches onLoad. In that
// race onLoad never fires, leaving the image stuck at opacity:0. Catch the
// already-complete case on mount via a ref so it is never permanently blank.
'use client'

import { useEffect, useRef, useState } from 'react'

function HeroImage({ src, alt }: { src?: string; alt: string }) {
  const [isImageLoaded, setIsImageLoaded] = useState(false)
  const heroImgRef = useRef<HTMLImageElement>(null)

  useEffect(() => {
    if (heroImgRef.current?.complete) {
      setIsImageLoaded(true)
    }
  }, [src])

  return (
    <img
      ref={heroImgRef}
      alt={alt}
      src={src}
      className={isImageLoaded ? 'loaded' : ''}
      onLoad={() => setIsImageLoaded(true)}
    />
  )
}

export default HeroImage
